import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "aria-hidden": "false",
  class: "fds-modal"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#close" })
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "modal-footer" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  id: "modal-backdrop",
  class: "modal-backdrop"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.title), 1),
          _createElementVNode("button", {
            "aria-label": "Luk",
            class: "modal-close button button-unstyled",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('select-reject')))
          }, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "button button-primary saveButton",
            "data-cy-id": "modal-confirm",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('select-ok', this.valueObject))),
            disabled: _ctx.buttonsDisabled
          }, [
            _createVNode(_component_SimpleText, { textKey: _ctx.buttonOkTextKey }, null, 8, ["textKey"])
          ], 8, _hoisted_9),
          _createElementVNode("button", {
            class: "button button-secondary saveButton",
            "data-cy-id": "modal-cancel",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('select-reject'))),
            disabled: _ctx.buttonsDisabled
          }, [
            _createVNode(_component_SimpleText, { textKey: _ctx.buttonRejectTextKey }, null, 8, ["textKey"])
          ], 8, _hoisted_10)
        ])
      ])
    ]),
    _hoisted_11
  ], 64))
}